
// resets a form by finding the closest form and resets the values
$(document).on('click', '[data-tncp-resetform]', function () {

    // iterate through filters
    let $filters = $(this).closest('form').find('[name^="tx_tuevnordcustomerportal_api[filter]"]');
    $filters.each((index,element) => {

        // remove value from hidden, text and selectboxes
        if (element.type === 'hidden' || element.type === 'text' || element.type === 'select-one') {
            $(element).val('')
        }

        // uncheck checkboxes / radio buttons
        if (element.type === 'checkbox' || element.type === 'radio') {
            $(element).prop('checked', false)
        }

    })

    // iterate through multiselect indicator fields
    let $multiselect = $(this).closest('form').find('[data-tncp-multiselect-indicator]');
    $multiselect.each((index,element) => {
        $(element).html("")
    })

    // triggers change on selectboxes
    $(this).closest('form').find('select').trigger('change');
});